export class BossCallMapping {
public id : any;
public network_id : string;
public operator_id : string;
public class_name : string;
public sales_rep_id : string;
public first_name : string;
public last_name : string;
public valid_from_dt : Date;
public valid_to_dt : Date;
public employee_id :string;
public feedDate :Date;
public email_id:String;
     constructor(){
         this.id = null;
        this.network_id = null;
        this.operator_id = null;
        this.class_name = null;
        this.sales_rep_id = null;
        this.first_name = null;
        this.last_name = null;
        this.valid_from_dt  = null;
        this.valid_to_dt  = null;
        this.employee_id  = null;
        this.feedDate = null;
        this.email_id = null;

     }
}
